import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import Table from "../Table/Table"


// import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import "./AddExceptionsExpensesForm.css"
import axios from "axios";
function AddExceptionsExpensesForm() {


  // eslint-disable-next-line react-hooks/rules-of-hooks
  const userinfo = useSelector((state) => state);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [selectedIds, setSelectedIds] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [notes, setNotes] = useState('');
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { id } = useParams();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const [Tuitionfees, setTuitionfees] = useState('');
  const [Transportationfees, setTransportationfees] = useState('');
  const [Mealfees, setMealfees] = useState('');
  const [Bookfees, setBookfees] = useState('');
  const [Studyexpenses, setStudyexpenses] = useState('');
  const [Distancetravelfees, setDistancetravelfees] = useState('')
  const [details, setDetails] = useState([
    { name: "مقدم الدفع", price: 0 },
    { name: "المبلغ الذي بدفع أول يوم دراسة", price: 0 },
    { name: "سبتمبر", price: 0 },
    { name: "أكتوبر", price: 0 },
    { name: "نوفمبر", price: 0 },
    { name: "ديسمبر", price: 0 },
    { name: "يناير", price: 0 },
    { name: "فبراير", price: 0 },
    { name: "مارس", price: 0 },
    { name: "أبريل", price: 0 },
    { name: "مايو", price: 0 },
        { name: "يونيه", price: 0 },
    { name: "يوليه", price: 0 },

  ]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [type_id, setType_id] = useState("");
  const [grade_id, setGrade_id] = useState("");
  const [class_id, setClass_id] = useState("");
  const [options, setOptions] = useState([])
  const [gradoptions, setgradoptions] = useState([])
  const [items, setItems] = useState([])

  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.image,
    currentLocal.home.nameStudent,
    currentLocal.home.stageName,
    currentLocal.home.gradeName,
    "",

  ]
  const [price, setPrice] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [email, setEmail] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [password, setPssword] = useState('')
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [phone, setPhone] = useState('')

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loading, setLoading] = useState('')
  useEffect(() => {
    const getData = async () => {

      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/students/schools/${userinfo?.auth?.userArray?.user?.school_id}/grade-categories`);

        const optionsRes = response.data.data.map(item => ({
          value: item.id,
          label: item.name
        }));

        setOptions(optionsRes);



      } catch (error) {
        setLoading(false)

      } finally {
        setLoading(false);
      }
      if (grade_id?.value) {
        try {
          const response = await axios.get(`https://nanosoft.space/taarteb/public/api/students/grade-categories/${grade_id?.value}/grades`);

          const optionsRes = response.data.data.map(item => ({
            value: item.id,
            label: item.name
          }));

          setgradoptions(optionsRes);



        } catch (error) {
          setLoading(false)

        } finally {
          setLoading(false);
        }
      }
      if (type_id?.value) {
        try {
          const response = await axios.get(`https://nanosoft.space/taarteb/public/api/admin/expenses`, {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          });





        } catch (error) {
          setLoading(false)

        } finally {
          setLoading(false);
        }
      }
      if (type_id?.value && grade_id?.value) {
        try {
          const response = await axios.get(`https://nanosoft.space/taarteb/public/api/admin/expenses/students?grade_category_id=${grade_id?.value}&grade_id=${type_id?.value}`, {
            headers: {
              Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
            },
          });
console.log(response.data.data);

          setItems(response.data.data);




        } catch (error) {
          setLoading(false)

        } finally {
          setLoading(false);
        }
      }

    }
    getData()
  }, [grade_id?.value, type_id?.value])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!price || selectedIds.length === 0) {
      toast.error("يجب إدخال السعر واختيار الطلاب");
      return;
    }
    setLoading(true)
    try {
      const response = await axios.post(
        `https://nanosoft.space/taarteb/public/api/admin/expenses/${id}/exceptions`,
        {
          exception_price: price,
          notes: notes,

          student_ids: selectedIds,
                    details: details,
            "installments": [
                { "name": "Tuitionfees", "price": Tuitionfees,is_optional:0 },
                { "name": "Transportationfees", "price": Transportationfees,is_optional:0 },
                { "name": "Mealfees", "price": Mealfees ,is_optional:0},
                { "name": "Bookfees", "price": Bookfees ,is_optional:0},
                { "name": "Studyexpenses", "price": Studyexpenses,is_optional:0 },
                { "name": "Distancetravelfees", "price": Distancetravelfees,is_optional:0 },

            ]
          // notes: notes
        },
        {
          headers: {
            Authorization: `Bearer ${userinfo.auth.userArray.access_token}`,
          },
        }
      );

      toast.success("تم الإضافة بنجاح");
      setPrice("");
      setSelectedIds([]);
      setLoading(false)

    } catch (error) {
      toast.error("فشل في الإرسال");
      setLoading(false)

    }
  };



  return (
    <div className='add_student_exp_form_container'>
      <ToastContainer />

      <form className='form_exp_container w-100'>
        <Container fluid>
          <Row>
            <Col md={4}>
              <div>
                <label>{currentLocal.home.stageName}</label>
                <br />
                <div className='mb-3'>
                  <Select
                    value={grade_id}
                    onChange={(selectedOption) => {
                      setGrade_id(selectedOption)
                      setType_id('')
                      setItems([])
                    }}
                    options={options}
                    placeholder={currentLocal.home.stageName} // Change this text

                  />
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div>
                <label>{currentLocal.home.grade}</label>
                <br />
                <div className='mb-3'>
                  <Select
                    value={type_id}
                    onChange={(selectedOption) => {
                      setItems([])

                      setType_id(selectedOption)
                    }}
                    options={gradoptions}
                    placeholder={currentLocal.home.grade} // Change this text

                  />
                </div>
              </div>
            </Col>
            {/* <Col md={3}>
                            <div>
                                <label>{currentLocal.home.class}</label>
                                <br />
                                <div className='mb-3'>
                                    <Select
                                        value={class_id}
                                        onChange={(selectedOption) => setClass_id(selectedOption)}
                                        options={classoptions}
                                        placeholder={currentLocal.home.class} // Change this text

                                    />
                                </div>
                            </div>
                        </Col> */}


            <Col md={12}>
              <Table
                data={items}
                headerIterm={headerIterm}
                actions={["check"]}
                onCheckChange={(ids) => setSelectedIds(ids)}
              />
            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.price}</label>
                <CustomInput
                  placeholder={currentLocal.home.price}
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
              </div>
            </Col>
            <Col md={6}>
              <div>
                <label>{currentLocal.home.notes}</label>
                <CustomInput
                  placeholder={currentLocal.home.ressonOfException}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </Col>
            <h5>تفاصيل المصاريف</h5>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم الدراسة</label>
              <CustomInput
                placeholder="رسوم الدراسة"
                type="number"
                value={Tuitionfees}
                onChange={(e) => setTuitionfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم نقل </label>
              <CustomInput
                placeholder="رسوم نقل "
                type="number"
                value={Transportationfees}
                onChange={(e) => setTransportationfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم وجبه </label>
              <CustomInput
                placeholder="رسوم وجبه "
                type="number"
                value={Mealfees}
                onChange={(e) => setMealfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم كتب </label>
              <CustomInput
                placeholder="رسوم كتب "
                type="number"
                value={Bookfees}
                onChange={(e) => setBookfees(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>التزمات دراسية </label>
              <CustomInput
                placeholder="التزمات دراسية "
                type="number"
                value={Studyexpenses}
                onChange={(e) => setStudyexpenses(e.target.value)}
              />

            </Col>
            <Col md={6}>
              <label style={{ width: '150px' }}>رسوم نقل بعيد </label>
              <CustomInput
                placeholder="رسوم نقل بعيد "
                type="number"
                value={Distancetravelfees}
                onChange={(e) => setDistancetravelfees(e.target.value)}
              />

            </Col>
            <h5 className='mt-4'>تفاصيل الدفع </h5>
            {details.map((item, index) => (
              <Col md={6} key={index} className=" mb-2">
                <label style={{ width: '250px' }}>{item.name == "مقدم الدفع" ? item.name + " " + "المبلغ يدفع عند التسجيل" : item.name}</label>
                <CustomInput
                  placeholder="السعر"
                  type="number"
                  value={item.price}
                  onChange={(e) => {
                    const newDetails = [...details];
                    newDetails[index].price = e.target.value;
                    setDetails(newDetails);
                  }}
                />
              </Col>
            ))}














            <Col md={12}>
              <div className='d-flex justify-content-center mt-4 '>
                <div className='w-50 d-flex justify-content-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.add} disabled={loading} clickingFunction={handleSubmit} />

                </div>
              </div>
            </Col>
          </Row>

        </Container>
      </form>
    </div>
  )
}

export default AddExceptionsExpensesForm